type Singles<T extends PropertyKey> = T extends infer U
  ? { [P in U extends PropertyKey ? U : never]: unknown }
  : never;

type Exactly<T, P> = T extends {}
  ? P & { [K in Exclude<keyof P, keyof T>]?: never }
  : never;

/**
 * Given a record T, only allow instances of Partial<T> with a single key.
 *
 * @example
 *
 * // Yields exactly `{ foo: string }`
 * ExactlyOne<{ foo: string; bar: number }, "foo">
 *
 * @example
 *
 * // Yields `never`
 * ExactlyOne<{ foo: string; bar: number }, "foo" | "bar">
 */
export type ExactlyOne<T, K extends keyof T> = Exactly<
  Singles<keyof T>,
  Pick<T, K>
>;
